export const preventDefault = (event: Event) => {
  if (!event) return
  if (event.preventDefault) event.preventDefault()
  if (event.stopPropagation) event.stopPropagation()
}
